import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from "react-spinners";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {langRegister} from "../../services/langRegister";
import ErrorHandler from "../../components/error-handler/component";
import {userRegister} from "../../services/userRegister";

class BoosterLoginToken extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: false
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        console.log(this.props.match.params.hash);
        if(this.props.match.params.hash){
            this.setState({isLoading: true});
            dataRegister.userToken(salesChannelRegister.get("market"), this.props.match.params.hash).then((response) => {
                if(!response.errors){

                    try {
                        if(response.socialData){
                            if(response.socialData.image){
                                salesChannelRegister.set('socialIcon-salesforce', salesChannelRegister.get('socialIcon'));
                                salesChannelRegister.set('socialIcon', response.socialData.image);
                            }
                            if(response.socialData.title){
                                salesChannelRegister.set('socialTitle-salesforce', salesChannelRegister.get('socialTitle'));
                                salesChannelRegister.set('socialTitle', response.socialData.title);
                            }
                            if(response.socialData.facebookID){
                                salesChannelRegister.set('facebookId-salesforce', salesChannelRegister.get('facebookId'));
                                salesChannelRegister.set('facebookId', response.socialData.facebookID);
                            }
                            if(response.socialData.instagramID){
                                salesChannelRegister.set('instagramId-salesforce', salesChannelRegister.get('instagramId'));
                                salesChannelRegister.set('instagramId', response.socialData.instagramID);
                            }
                        }
                    }catch (e) {}

                    userRegister.set(response);
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running");
                }else{
                    this.setState({isLoading: false, error: true});
                }
            }, (error) => {
                this.setState({isLoading: false, error: true});
            });
        }else{
            this.setState({isLoading: false, error: true});
        }
    }

    render() {
        return (
            <div className={Styles.container}>
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler/>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterLoginToken;


// WEBPACK FOOTER //
// ./src/pages/booster-login-token/component.js